export const JOB_INVOCATIONS_POLLING_STARTED =
  'JOB_INVOCATIONS_POLLING_STARTED';
export const JOB_INVOCATIONS_GET_JOB_INVOCATIONS =
  'JOB_INVOCATIONS_GET_JOB_INVOCATIONS';
export const JOB_INVOCATIONS_JOB_FINISHED = 'JOB_INVOCATIONS_JOB_FINISHED';



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_remote_execution-10.1.1/webpack/react_app/redux/consts.js